import { render, staticRenderFns } from "./HistoryDatasetPermissions.vue?vue&type=template&id=5043d7cb"
import script from "./HistoryDatasetPermissions.vue?vue&type=script&lang=ts&setup=true"
export * from "./HistoryDatasetPermissions.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports